import { createContext, useContext } from 'react';

import { MissionOperationType } from '../types/state/missions';

type MissionBannerContextProps = {
  betRedirectionOnClick: () => void;
  operationType?: MissionOperationType;
};

export const MissionBannerContext = createContext<MissionBannerContextProps>({
  betRedirectionOnClick: () => {},
});

export const useMissionBannerContext = () => useContext(MissionBannerContext);
